import React from 'react'
import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'
import dynamic from 'next/dynamic'

const GooglePlay = dynamic(() => import('@/components/common/google-play-btn'))
const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))
const GuideBanner = dynamic(() => import('@/components/guide/banner'))
const GuideBenefit = dynamic(() => import('@/components/guide/benefit'))

const resource = createResource({
  en: {
    description:
      'Pay in time and get Pintar Score so your Kredit Pintar loan limit becomes higher! You also can borrow more than 1 loan at same time, gifts and discount!',
  },
  id: {
    description:
      'Bayar tepat waktu dan dapatkan Skor Pintar agar limit pinjaman Kredit Pintar-mu jadi besar, anda juga dapat pinjam lebih dari 1 pinjaman bersamaan, hadiah serta diskon!',
  },
})

export default function Guide() {
  const { t } = useResource(resource)

  return (
    <>
      <KPHead metaTitle="pintarScore" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation />
      <GuideBanner />
      <GuideBenefit />
      <Footer />
      <GooglePlay />
    </>
  )
}
